export class ExtendedLuShu {
    constructor({
        map,
        lushu
    }) {
        this.map = map;
        this.lushu = lushu;

        this.currentActive = ExtendedLuShu.ActiveName.STOP;

        /**
         * 事件回调函数的MAP, Map<eventName, function[]>
         */
        this.eventCallbackMap = new Map();

        /**
         * MOVE状态下的定时器
         */
        this.moveTimer = 0;
    };

    static ActiveName = {
        MOVE: 'move',
        PAUSE: 'pause'
    };

    start () {
        this.lushu.start();
        this.currentActive = ExtendedLuShu.ActiveName.MOVE;
        // 设置定时器，定时触发move事件
        this.moveTimer = setInterval(() => {
            this._trigger('move');
            // 当前状态不为move或运动结束时，关闭定时器
            if (this.currentActive !== ExtendedLuShu.ActiveName.MOVE || this.lushu.i === this.lushu.path.length - 1) {
                clearInterval(this.moveTimer);
            }
        }, 100);
    };

    pause () {
        this.lushu.pause();
        this.currentActive = ExtendedLuShu.ActiveName.PAUSE;
        clearInterval(this.moveTimer);
    };

    /**
     * 设置速度
     * @param {*} speed
     */
    setSpeed (speed) {
        if (!this.lushu._opts) return;
        this.lushu._opts.speed = speed;
    };

    /**
     * 监听路书的事件
     * @param {string} eventName 事件名称 'move' | 'stop' | 'start' | 'pause'
     * @param {function} callback 事件回调函数
     */
    on (eventName, callback) {
        // 根据事件名称将一个事件处理函数放入对应的事件处理函数数组中
        const fns = this.eventCallbackMap.get(eventName) || [];
        fns.push(callback);
        this.eventCallbackMap.set(eventName, fns);
    };

    /**
     * 触发事件
     * @param {*} eventName
     */
    _trigger (eventName) {
        // 取出事件名称对应的所有事件处理函数，并依次调用这些函数
        const fns = this.eventCallbackMap.get(eventName) || [];
        for (const fn of fns) {
            fn({
                eventName,
                tracedInPercent: (this.lushu.i + 1) / this.lushu.path.length * 100,
                pointIndex: this.lushu.i,
                pointPath: this.lushu.path
            });
        }
    };

    // 清空所有事件处理函数并置空路书
    clear () {
        clearInterval(this.moveTimer);
        this.eventCallbackMap = new Map();
        this.lushu = null;
    };
}
